import { HubTrucksModel } from '../../models';

export class HubTrucksLoad {
  public static readonly type = '[HubTrucks] Load Trucks';
  constructor(public payload: string) {}
}

export class HubTrucksUpdate {
  public static readonly type = '[HubTrucks] Update Trucks';
  constructor(public payload: { hubId: number; hubTruckMapping: HubTrucksModel }) {}
}

export class HubTrucksInitialState {
  public static readonly type = '[HubTrucks] Set Initial State';
}
